import api from "../index"

const reports = api.injectEndpoints({
  endpoints: (build) => ({
    getWealthReportsData: build.query({
      query: ({ date }) => ({
        url: `/wealthPartner/reports/financial-report?date=${encodeURIComponent(
          JSON.stringify(date)
        )}`,
        method: "GET",
      }),
    }),
    getWealthAdminOffers: build.query({
      query: () => ({
        url: `/wealthPartner/reports/admin/offers`,
        method: "GET",
      }),
    }),
    getWealthDashboardStats: build.query({
      query: () => ({
        url: `/wealthPartner/reports/dashboard/stats`,
        method: "GET",
      }),
    }),
    getWealtDashboardPayableAmountChart: build.query({
      query: (body) => ({
        url: `/wealthPartner/reports/dashboard/payable/amount/chart`,
        method: "POST",
        body,
      }),
    }),
    getWealtDashboardCompaniesAgreements: build.query({
      query: (body) => ({
        url: `/wealthPartner/reports/dashboard/agreements`,
        method: "POST",
        body,
      }),
    }),
    getDashboardReferralTracking: build.query({
      query: (body) => ({
        url: `/wealthPartner/reports/dashboard/referral/tracking`,
        method: "POST",
        body,
      }),
    }),
    getDashboardMaturityTracking: build.query({
      query: (body) => ({
        url: `/wealthPartner/reports/dashboard/maturity`,
        method: "POST",
        body,
      }),
    }),
    getDashboardTopPerformer: build.query({
      query: (body) => ({
        url: `/wealthPartner/reports/dashboard/top/performer`,
        method: "POST",
        body,
      }),
    }),
    getTdsCerificatesWp: build.query({
      query: ({ type }) => ({
        url: `/wealthPartner/reports/tds/${type}`,
        method: "GET",
      }),
    }),
    getInvestorcommissionWp: build.query({
      query: () => ({
        url: `/wealthPartner/reports/commission`,
        method: "GET",
      }),
    }),
    getInvestorcommission: build.query({
      query: () => ({
        url: `/wealthPartner/reports/commission`,
        method: "GET",
      }),
    }),
  }),
})

export const {
  useLazyGetWealthReportsDataQuery,
  useLazyGetWealthAdminOffersQuery,
  useLazyGetWealthDashboardStatsQuery,
  useLazyGetWealtDashboardPayableAmountChartQuery,
  useLazyGetWealtDashboardCompaniesAgreementsQuery,
  useLazyGetDashboardReferralTrackingQuery,
  useLazyGetDashboardMaturityTrackingQuery,
  useLazyGetDashboardTopPerformerQuery,
  useLazyGetTdsCerificatesWpQuery,
  useLazyGetInvestorcommissionWpQuery,
} = reports
